import ng from 'angular';
import acpModalStateCtrl from './acp-modal-state-ctrl';

// @ngInject
function acpModalStateProvider() {
  var acpModalStateProvider = this;

  acpModalStateProvider.createModalState = function(modalServiceName) {
    return {
      abstract: true,
      url: '',
      controller: 'acpModalStateCtrl',
      onEnter: /* @ngInject */ function($modal, $state, $postModalRedirect) {
        // If we close the modal but do not exit, we should redirect
        var context = this;
        $modal.$result.finally(function() {
          /* eslint-disable-next-line es5/no-es6-methods */
          if ($state.includes(context)) {
            $postModalRedirect();
          }
        });
      },
      onExit: /* @ngInject */ function($modal, $cancel) {
        // If we exit the state but do not close the modal, we should close it
        if (!$modal.$closed) {
          $cancel();
        }
      },
      resolve: {
        $$modalDefer: /* @ngInject */ function($q) {
          return $q.defer();
        },
        $modal: /* @ngInject */ function($$modalDefer) {
          var $modal = {
            $result: $$modalDefer.promise,
            $closed: false
          };
          $modal.$result.finally(function() {
            $modal.$closed = true;
          });
          return $modal;
        },
        $hide: [
          modalServiceName,
          function(modalService) {
            return modalService.hide;
          }
        ],
        $show: [
          modalServiceName,
          '$$modalDefer',
          function(modalService, $$modalDefer) {
            return function(opts) {
              return modalService
                .show(opts)
                .then($$modalDefer.resolve, $$modalDefer.reject);
            };
          }
        ],
        $cancel: [
          modalServiceName,
          function(modalService) {
            return modalService.cancel;
          }
        ],
        $postModalRedirect: /* @ngInject */ function($state, $injector) {
          return function() {
            var postModalRedirect =
              $state.current.data && $state.current.data.postModalRedirect;
            if (
              ng.isFunction(postModalRedirect) ||
              Array.isArray(postModalRedirect)
            ) {
              postModalRedirect = $injector.invoke(postModalRedirect);
            }
            if (postModalRedirect) {
              $state.go(
                postModalRedirect.state || postModalRedirect,
                postModalRedirect.params || null
              );
              return true;
            }
          };
        }
      }
    };
  };

  acpModalStateProvider.$get = ng.noop;
}

function mixinDependencies(appModule) {
  appModule
    .controller('acpModalStateCtrl', acpModalStateCtrl)
    .provider('acpModalState', acpModalStateProvider);
}
export default mixinDependencies;
